module.exports = __webpack_public_path__ + "static/media/animal-cat1.658c1ef5.aac";